__turbopack_context__.v({
  "actions": "ConsentBanner-module__j75xkW__actions",
  "banner": "ConsentBanner-module__j75xkW__banner",
  "link": "ConsentBanner-module__j75xkW__link",
  "text": "ConsentBanner-module__j75xkW__text",
});
